import React from "react";
import { _aligeText, _size, _typeLabel } from "../../core/core";
import "./label.css";

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  type?: _typeLabel;
  size?: _size;
  aligeText?: _aligeText;
  status?: string;
  className?: string;
  children?: React.ReactNode;
}

export const Label: React.FC<LabelProps> = ({
  type = _typeLabel.primary,
  size = _size.S,
  aligeText = _aligeText.left,
  className,
  status,
  children,
  ...props
}) => {
  // Генерация классов
  const getClassNames = (): string => {
    const baseClass = `label-common label-${type} label-${size} text-${aligeText} ${className}`;
    return status ? `${baseClass} status-${status}` : baseClass;
  };

  return (
    <label className={getClassNames()} {...props}>
      {children}
    </label>
  );
};
